module.exports = __webpack_public_path__ + "static/img/higiene-industrial.cec1bcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguros-arl/Especialidades/higiene-industrial.png
// module id = bpza
// module chunks = 0